// API client for the workspace's texting hours (ticket 202-3).
import { api } from './api';

export const smsWindowApi = {
  get: () => api.get('/tenants/mine/sms-window').then(r => r.data),
  set: (start_hour, end_hour) => api.put('/tenants/mine/sms-window', { start_hour, end_hour }).then(r => r.data),
  // Back to the company default.
  reset: () => api.delete('/tenants/mine/sms-window').then(r => r.data),
};
